var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"title":"Open holder entity in new tab","icon":_vm.$icons.open_holder},on:{"action":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }